<template>
  <div class="main pages-videos-details">
    <div class="title-bar d-none d-lg-block">
      <a v-if="video.enable_sharing"
         class="btn btn-primary float-right"
         href="#"
         @click.prevent="share()">
	      Share This Video
      </a>
      <h1 class="mb-0">{{ video.title }}</h1>
      <a class="btn-back text-primary" :href="route('videos.index')">
        <span class="icon icon-arrow-left"></span>
        <span class="text">Back to List</span>
      </a>
    </div>
    <div class="row no-gutters p-lg-4">
      <div class="col-12">
        <transition name="fade">
          <Alert v-if="hasAlert" :alert="alert" />
        </transition>
      </div>

    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";

export default {
	mixins: [DisplaysAlerts],
	props: {
		learningPath: {type: Object, required: true},
	},
	methods: {
		//
	},
};
</script>
